export interface Bank {
  id: number;
  name: string;
  nameEn?: string;
  nameMx?: string;
}

export const VERQOR_BANK_ID = 9;
